var _rect, _defs, _use, _clipPath, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path, _polygon, _polygon2, _polygon3, _polygon4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path2, _g10, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3000,
    height: 2500,
    enableBackground: "new 0 0 3000 2500",
    viewBox: "0 0 3000 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 2500,
    fill: "#FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M488.663,2036.346c0,0-733.692-405.621-108.604-952.747 c625.088-547.124,1511.959-683.663,2025.648-472.793c513.687,210.872,793.362,1081.664,180.653,1425.54H488.663z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#E6F5FF",
    overflow: "visible",
    xlinkHref: "#a"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    d: "M-591.984,1134.831 c-264.234,528.798,235.888,979.31,752.104,956.822c516.213-22.486,434.059,902.14-211.869,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 1.222,
    d: "M-501.411,1103.852 c-264.233,528.798,235.888,979.31,752.104,956.822c516.214-22.486,434.059,902.14-211.869,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 1.444,
    d: "M-410.837,1072.871 c-264.234,528.799,235.888,979.311,752.104,956.822c516.214-22.486,434.059,902.141-211.869,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 1.667,
    d: "M-320.264,1041.892 c-264.233,528.798,235.888,979.31,752.105,956.822c516.213-22.486,434.058,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 1.889,
    d: "M-229.689,1010.911 c-264.234,528.798,235.888,979.31,752.104,956.822c516.214-22.486,434.059,902.139-211.869,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 2.111,
    d: "M-139.115,979.931 c-264.234,528.799,235.888,979.311,752.104,956.823c516.214-22.486,434.058,902.14-211.869,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 2.333,
    d: "M-48.542,948.951 c-264.234,528.798,235.888,979.31,752.104,956.822c516.214-22.486,434.059,902.14-211.87,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 2.555,
    d: "M42.032,917.971 c-264.234,528.798,235.888,979.31,752.104,956.822c516.214-22.485,434.059,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 2.778,
    d: "M132.606,886.991 c-264.234,528.798,235.888,979.31,752.104,956.823c516.214-22.485,434.059,902.14-211.87,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M223.18,856.011 c-264.234,528.798,235.888,979.31,752.104,956.822c516.214-22.485,434.058,902.14-211.87,975.138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 3.222,
    d: "M313.754,825.031 c-264.233,528.797,235.888,979.31,752.104,956.823c516.215-22.486,434.059,902.139-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 3.444,
    d: "M404.328,794.051 c-264.234,528.798,235.888,979.31,752.104,956.822c516.214-22.486,434.058,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 3.667,
    d: "M494.902,763.07 c-264.234,528.799,235.888,979.311,752.105,956.822c516.214-22.485,434.058,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 3.889,
    d: "M585.476,732.09 c-264.233,528.799,235.888,979.311,752.104,956.823c516.215-22.485,434.059,902.14-211.869,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 4.111,
    d: "M676.05,701.11 c-264.233,528.798,235.888,979.31,752.104,956.823c516.215-22.485,434.059,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 4.333,
    d: "M766.624,670.13 c-264.234,528.798,235.888,979.311,752.104,956.823c516.215-22.486,434.058,902.14-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 4.556,
    d: "M857.198,639.15 c-264.234,528.798,235.887,979.311,752.104,956.822c516.215-22.485,434.057,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 4.778,
    d: "M947.772,608.17 c-264.234,528.799,235.887,979.311,752.104,956.822c516.216-22.484,434.058,902.141-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M1038.346,577.189 c-264.233,528.799,235.888,979.311,752.104,956.823c516.215-22.485,434.058,902.14-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 5.222,
    d: "M1128.919,546.21 c-264.234,528.798,235.888,979.311,752.104,956.822c516.216-22.485,434.059,902.14-211.869,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 5.444,
    d: "M1219.493,515.229 c-264.233,528.798,235.888,979.311,752.104,956.823c516.216-22.486,434.058,902.139-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 5.667,
    d: "M1310.067,484.249 c-264.233,528.799,235.888,979.312,752.104,956.823c516.216-22.485,434.058,902.14-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 5.889,
    d: "M1400.642,453.27 c-264.234,528.799,235.888,979.311,752.104,956.822c516.215-22.484,434.058,902.14-211.87,975.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 6.111,
    d: "M1491.216,422.289 c-264.234,528.799,235.888,979.311,752.104,956.823c516.216-22.485,434.058,902.14-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 6.333,
    d: "M1581.789,391.309 c-264.233,528.798,235.888,979.311,752.105,956.823c516.215-22.484,434.057,902.14-211.871,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 6.556,
    d: "M1672.363,360.329 c-264.233,528.799,235.888,979.311,752.104,956.823c516.216-22.485,434.058,902.139-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 6.778,
    d: "M1762.938,329.349 c-264.234,528.799,235.887,979.312,752.104,956.823c516.216-22.484,434.057,902.14-211.871,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    d: "M1853.511,298.369 c-264.233,528.798,235.889,979.311,752.105,956.822c516.215-22.484,434.057,902.14-211.871,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 7.222,
    d: "M1944.085,267.389 c-264.233,528.799,235.888,979.312,752.104,956.823c516.217-22.485,434.058,902.14-211.87,975.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 7.444,
    d: "M2034.659,236.409 c-264.233,528.798,235.888,979.311,752.104,956.823c516.216-22.484,434.057,902.14-211.871,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 7.667,
    d: "M2125.233,205.428 C1861,734.228,2361.12,1184.74,2877.338,1162.252c516.216-22.485,434.057,902.139-211.871,975.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 7.889,
    d: "M2215.808,174.448 c-264.234,528.799,235.888,979.312,752.104,956.823c516.217-22.484,434.058,902.14-211.87,975.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 8.111,
    d: "M2306.381,143.468 c-264.233,528.798,235.888,979.311,752.104,956.823c516.216-22.484,434.057,902.14-211.87,975.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 8.333,
    d: "M2396.955,112.488 c-264.233,528.799,235.888,979.312,752.104,956.823c516.216-22.484,434.057,902.14-211.871,975.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 8.556,
    d: "M2487.528,81.508 c-264.233,528.798,235.889,979.311,752.105,956.823c516.217-22.484,434.057,902.14-211.871,975.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 8.778,
    d: "M2578.103,50.528 c-264.233,528.799,235.888,979.311,752.104,956.824c516.217-22.484,434.057,902.14-211.871,975.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 9,
    d: "M2668.677,19.548 c-264.233,528.799,235.888,979.312,752.104,956.823c516.217-22.484,434.057,902.14-211.871,975.135"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1758.022,
    height: 98.396,
    x: 736,
    y: 2070.668,
    fill: "#AAA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1850.361,
    height: 98.398,
    x: 736,
    y: 1980.225,
    fill: "#C9C9C9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 495.851,
    height: 283.803,
    x: 1213.156,
    y: 858.634,
    fill: "#BBE2EF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 41.925,
    height: 41.926,
    x: 1243.256,
    y: 884.3,
    fill: "#FFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 220.109,
    height: 16.394,
    x: 1299.963,
    y: 884.3,
    fill: "#FFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 111.534,
    height: 16.394,
    x: 1299.963,
    y: 909.832,
    fill: "#FFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 41.925,
    height: 41.926,
    x: 1243.256,
    y: 949.041,
    fill: "#FFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 220.109,
    height: 16.395,
    x: 1299.963,
    y: 949.041,
    fill: "#FFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 111.534,
    height: 16.393,
    x: 1299.963,
    y: 974.574,
    fill: "#FFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 41.925,
    height: 41.926,
    x: 1243.256,
    y: 1013.783,
    fill: "#FFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 220.109,
    height: 16.394,
    x: 1299.963,
    y: 1013.783,
    fill: "#FFF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 111.534,
    height: 16.393,
    x: 1299.963,
    y: 1039.316,
    fill: "#FFF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 41.925,
    height: 41.925,
    x: 1243.256,
    y: 1078.526,
    fill: "#FFF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 220.109,
    height: 16.392,
    x: 1299.963,
    y: 1078.526,
    fill: "#FFF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 111.534,
    height: 16.395,
    x: 1299.963,
    y: 1104.057,
    fill: "#FFF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 157.221,
    height: 122.687,
    x: 1538.079,
    y: 881.881,
    fill: "#FFF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 157.221,
    height: 104.734,
    x: 1538.079,
    y: 1019.561,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ECC36",
    d: "M1552.591 974.574c10.079-26.58 27.011-57.486 40.313-39.749 13.304 17.737 32.25 36.227 36.685 30.61 4.437-5.617 14.11-23.759 25.802-25.37 11.689-1.612 31.846 34.509 31.846 34.509H1552.591zM1552.591 1101.016c10.079-26.579 27.011-57.488 40.313-39.75 13.304 17.738 32.25 36.229 36.685 30.611 4.437-5.616 14.11-23.757 25.802-25.369 11.689-1.613 31.846 34.508 31.846 34.508H1552.591z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF8500",
    points: "1245.944 903.784 1256.157 920.178 1282.227 898.678 1280.882 897.333 1256.392 913.56 1246.717 902.776"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF8500",
    points: "1245.944 966.377 1256.157 982.771 1282.227 961.271 1280.882 959.927 1256.392 976.152 1246.717 965.369"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF8500",
    points: "1245.944 1028.97 1256.157 1045.363 1282.227 1023.865 1280.882 1022.521 1256.392 1038.746 1246.717 1027.962"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF8500",
    points: "1245.944 1091.563 1256.157 1107.957 1282.227 1086.457 1280.882 1085.113 1256.392 1101.339 1246.717 1090.555"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 495.851,
    height: 283.805,
    x: 2107.546,
    y: 1238.705,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 198.339,
    height: 11.826,
    x: 2146.602,
    y: 1270.513,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.638,
    height: 11.825,
    x: 2146.602,
    y: 1292.552,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 198.339,
    height: 11.826,
    x: 2146.602,
    y: 1334.477,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.638,
    height: 11.825,
    x: 2146.602,
    y: 1356.515,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 198.339,
    height: 11.826,
    x: 2146.602,
    y: 1398.439,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.638,
    height: 11.825,
    x: 2146.602,
    y: 1420.478,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 198.339,
    height: 11.827,
    x: 2146.602,
    y: 1462.403,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116.638,
    height: 11.826,
    x: 2146.602,
    y: 1484.442,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8500",
    d: "M2564.242,1386.348c0,48.537-39.348,87.884-87.883,87.884c-48.537,0-87.882-39.347-87.882-87.884 c0-48.535,39.345-87.882,87.882-87.882c3.111,0,6.19,0.162,9.223,0.485l-9.223,87.396l86.855-13.446 C2563.894,1377.287,2564.242,1381.778,2564.242,1386.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ECC36",
    d: "M2571.01,1365.145l-86.857,13.447l9.225-87.398C2533.126,1295.337,2564.996,1325.976,2571.01,1365.145z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 275.55,
    height: 356.129,
    x: 2107.996,
    y: 664.331,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.997,
    height: 15.644,
    x: 2145.271,
    y: 693.491,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.997,
    height: 15.645,
    x: 2145.271,
    y: 724.349,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.997,
    height: 15.645,
    x: 2145.271,
    y: 755.207,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136.089,
    height: 15.644,
    x: 2145.271,
    y: 786.065,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.997,
    height: 15.646,
    x: 2145.271,
    y: 816.922,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.997,
    height: 15.645,
    x: 2145.271,
    y: 847.78,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100.498,
    height: 86.129,
    x: 2245.771,
    y: 910.508,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.248,
    height: 86.129,
    x: 2145.271,
    y: 910.508,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100.499,
    height: 15.644,
    x: 2145.271,
    y: 878.639,
    fill: "#FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 275.55,
    height: 356.13,
    x: 1771.329,
    y: 779.173,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.996,
    height: 15.645,
    x: 1808.605,
    y: 908.729,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.996,
    height: 15.644,
    x: 1808.605,
    y: 939.587,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.7,
    height: 15.644,
    x: 1906.901,
    y: 824.532,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.967,
    height: 15.644,
    x: 1906.901,
    y: 855.389,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.7,
    height: 15.644,
    x: 1906.901,
    y: 1026.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.967,
    height: 15.644,
    x: 1906.901,
    y: 1056.957,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.77,
    height: 80.078,
    x: 1811.844,
    y: 1012.887,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100.497,
    height: 15.644,
    x: 1808.605,
    y: 970.445,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1836.946,
    cy: 838.595,
    r: 23.873,
    fill: "none",
    stroke: "#FF8500",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1852.816,
    x2: 1891.153,
    y1: 856.421,
    y2: 892.466,
    fill: "none",
    stroke: "#FF8500",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 495.851,
    height: 283.802,
    x: 1413.254,
    y: 1186.453,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.879,
    height: 54.307,
    x: 1494.65,
    y: 1369.501,
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.877,
    height: 86.4,
    x: 1549.064,
    y: 1337.407,
    fill: "#8ECC36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.879,
    height: 108.614,
    x: 1603.476,
    y: 1315.193,
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.88,
    height: 63.484,
    x: 1657.888,
    y: 1360.323,
    fill: "#8ECC36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.877,
    height: 117.899,
    x: 1712.302,
    y: 1305.908,
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.877,
    height: 161.95,
    x: 1766.715,
    y: 1261.857,
    fill: "#8ECC36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8ECC36",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M1461.093,1342.831 c-1.613,1.952,162.864-90.5,162.864-90.5l37.108,53.577l133.819-85.826"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.452,
    height: 11.824,
    x: 1449.804,
    y: 1220.082,
    fill: "#E6F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.051,
    height: 11.824,
    x: 1449.804,
    y: 1245.613,
    fill: "#E6F5FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 172.737,
    height: 14.1,
    x: 2123.847,
    y: 1068.728,
    fill: "#8ECC36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118.759,
    height: 14.101,
    x: 2123.847,
    y: 1094.118,
    fill: "#8ECC36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 142.087,
    height: 14.101,
    x: 2123.847,
    y: 1119.507,
    fill: "#8ECC36"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 82.635,
    height: 14.101,
    x: 2123.847,
    y: 1144.897,
    fill: "#8ECC36"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 167.165,
    height: 20.347,
    x: 1367.484,
    y: 674.863,
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 249.263,
    height: 20.347,
    x: 1285.387,
    y: 711.501,
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 163.232,
    height: 20.347,
    x: 1293.613,
    y: 748.139,
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119.242,
    height: 20.348,
    x: 1285.387,
    y: 784.777,
    fill: "#FF8500"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 210.325,
    height: 17.17,
    x: 1459.34,
    y: 1529.291,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.652,
    height: 17.168,
    x: 1459.34,
    y: 1560.207,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 210.325,
    height: 17.169,
    x: 1459.34,
    y: 1591.122,
    fill: "#BBE2EF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100.615,
    height: 17.169,
    x: 1459.34,
    y: 1622.037,
    fill: "#BBE2EF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 870.949,
    height: 28.244,
    x: 1339.267,
    y: 1951.887,
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "1546.209 1951.887 2210.232 1951.887 2447.901 1572.25 1783.882 1572.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "2405.539 1617.311 2214.553 1922.371 1578.841 1922.371 1769.826 1617.311"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#565656",
    points: "2447.901 1572.25 2453.252 1587.781 2210.216 1980.131 2210.232 1951.887"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC7B",
    d: "M1128.339,1992.601c11.169,4.306,6.184,4.683,23.509,17.636c17.325,12.946,53.553,24.996,69.575,25.818 c16.023,0.822,28.269-0.429,34.212-8.684c5.942-8.26,2.719-16.473-5.914-19.601c-8.634-3.13-17.993-5.087-17.993-5.087 s70.074-5.873,109.282-8.622c39.21-2.745,68.177-5.423,70.859-18.72c2.682-13.296-20.98-18.229-40.315-16.172 c-19.335,2.059-48.632,2.89-48.632,2.89s105.154-21.911,107.089-36.099c1.936-14.188-14.077-8.696-48.373-5.508 c-34.295,3.189-58.531,2.827-58.531,2.827s95.696-26.89,97.766-40.735c2.07-13.847-4.394-17.235-44.74-7.325 c-40.35,9.908-60.785,13.187-60.785,13.187s71.412-30.393,70.965-45.622c-0.446-15.229-8.801-11.355-45.323-1.761 c-36.525,9.592-84.093,1.599-147.385,16.955c-63.29,15.356-100.496,35.288-100.496,35.288L1128.339,1992.601z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M2113.447,1980.277h-154.886c0,0,6.996,0,26.902-18.029c19.913-18.037,59.726-71.107,119.451-102.566 c0,0,17.176,60.049,18.251,95.397C2123.618,1969.988,2121.204,1980.498,2113.447,1980.277z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M2426.923,2045.293c-46.074,42.856-141.197,174.282-191.271,101.815 c-27.066-39.171,89.736-97.55,125.572-113.761c35.835-16.211,35.835-52.048,35.835-52.048s-11.194,0.905-28.515,2.057 c-55.204,3.652-172.616,9.778-188.204-3.079c-9.549-7.885-24.854-20.998-38.473-32.747 c-15.571-13.438-28.933-25.102-28.933-25.102l2.518-80.025c36.681-70.143,194.577-72.813,268.81-28.446 C2458.492,1858.326,2472.997,2002.435,2426.923,2045.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M2368.545,1983.356c-22.713,1.502-55.972,3.421-88.326,4.275c-46.271,1.202-90.705,0.213-99.878-7.354 c-8.226-6.793-20.717-17.457-32.721-27.789c-1.938-1.674-3.857-3.328-5.752-4.958c1.553-31.596,3.175-64.222,3.175-64.222 l-5.973-67.534c49.486-12.798,84.427,3.413,92.123,16.212c7.704,12.797,17.089,8.532,45.245,18.771 c28.157,10.238,51.195-11.093,64.846,17.063c13.651,28.158-22.354,54.898-18.429,75.23c3.923,20.332,23.548,23.601,34.64,21.963 C2364.56,1963.972,2369.202,1973.271,2368.545,1983.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M2113.447 1980.277h-153.981c8.926-3.526 19.768-11.206 39.036-13.694 11.065-1.43 74.984-6.854 78.12-11.732 5.854-9.104 20.58-17.841 39.666-2.662 1.852 1.468 4.174 2.397 6.878 2.891C2123.618 1969.988 2121.204 1980.498 2113.447 1980.277zM2299.184 1987.632c-46.271 1.202-109.67.213-118.843-7.354-8.226-6.793-20.717-17.457-32.721-27.789 27.431-7.134 61.815-23.815 70.229-16.264 12.517 11.228 33.302-.104 35.987 13.533 2.698 13.625 6.15 16.609 23.173 25.313C2281.735 1977.485 2296.718 1984.32 2299.184 1987.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M2249.399,1914.467c-6.363,24.991-13.805,41.382-23.498,52.048c-13.692,15.067-31.866,18.72-57.848,19.053 c-44.367,0.571-54.606-5.29-54.606-5.29c-71.671-63.541-26.731-160.808,32.993-165.927c32.502-2.782,64.658,9.248,84.753,30.511 C2248.035,1862.678,2256.405,1886.978,2249.399,1914.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAA03D",
    d: "M2236.884,1896.831c78.212-30.431,85.95,0,85.95,0s3.639,26.167-83.675,30.147 c-35.304,1.609-2.275-27.199-2.275-27.199V1896.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAA03D",
    d: "M2249.399,1914.467c-6.363,24.991-13.805,41.382-23.498,52.048c-30.895,1.245-45.074-16.46-45.877-28.302 c-0.844-12.5-32.848-8.106-27.285-23.037c5.554-14.932,15.34-18.345,24.299-31.867c8.96-13.525,26.45-3.115,54.155-38.447 C2248.035,1862.678,2256.405,1886.978,2249.399,1914.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M2128.054,1855.591c-59.781-58.901-35.185-78.42-35.185-78.42s22.384-14.03,61.759,64.003 c15.92,31.552-23.884,13.21-23.884,13.21L2128.054,1855.591z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    d: "M2109.185,1960.961c0,11.318,10.522,16.643,18.203,12.945c7.678-3.697,4.549-8.828-5.688-12.945 C2111.46,1956.842,2109.185,1955.125,2109.185,1960.961z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A0A0A0",
    points: "2158.409 1949.101 2259.068 1954.851 2158.364 1949.953"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A0A0A0",
    points: "2156.53 1954.446 2249.967 1985.606 2156.264 1955.257"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A0A0A0",
    points: "2152.956 1958.432 2231.195 2005.901 2152.515 1959.163"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A0A0A0",
    points: "2107.832 1936.621 2014.184 1899.272 2108.146 1935.828"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A0A0A0",
    points: "2111.31 1932.148 2032.561 1872.986 2111.819 1931.463"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A0A0A0",
    points: "2115.963 1929.5 2056.796 1859.686 2116.611 1928.945"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAA03D",
    d: "M2231.195 1785.61c1.304 22.06 22.634 38.33 30.739 32.327 8.105-6.002 14.162-16.62 21.159-6.832 6.998 9.789 7.851 15.107 21.929 2.85 14.078-12.26 38.307-17.51 38.307-17.51S2289.759 1777.912 2231.195 1785.61zM2350.244 1909.63c-13.763 9.656-17.065 9.37-9.813 22.177 7.253 12.806 25.209 17.071 28.176 2.14C2371.573 1919.016 2359.363 1903.229 2350.244 1909.63z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC7B",
    d: "M1690.207,1907.711c8.824-8.089,4.044-6.617,15.441-25.002c11.397-18.383,40.72-42.833,55.333-49.451 c14.615-6.619,26.475-9.929,35.023-4.412c8.547,5.514,8.547,14.339,1.654,20.404c-6.894,6.067-14.891,11.306-14.891,11.306 s67.378-20.128,104.879-31.894s65.445-19.855,72.8-8.457c7.354,11.398-12.869,24.633-31.621,29.779 c-18.752,5.148-46.326,15.078-46.326,15.078s105.889-18.019,112.875-5.517c6.985,12.499-9.929,13.237-43.018,22.796 c-33.092,9.56-55.518,18.752-55.518,18.752s98.904-9.928,105.889,2.206c6.985,12.133,2.205,17.647-38.974,23.163 c-41.179,5.515-61.4,9.928-61.4,9.928s77.579,2.205,82.725,16.545c5.146,14.337-4.044,13.787-41.545,18.198 c-37.505,4.413-78.868,29.229-143.395,38.056c-64.526,8.823-106.442,3.858-106.442,3.858L1690.207,1907.711z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6D2FC",
    d: "M665.448,1176.752c-130.472,79.073-98.955,202.61-83.829,416.599 c15.125,213.984,17.332,442.919,17.332,442.919h123.539l119.126-332.618L665.448,1176.752z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC7B",
    d: "M788.67,967.938c-8.409,55.665-15.442,124.641-46.327,145.598c0,0-3.31,37.504,124.641,48.533 c127.951,11.031,197.441,25.37,197.441,25.37s-91.183-33.091-88.977-92.654c2.206-59.563-2.941-77.409,39.709-73.266 c42.648,4.145,58.828,0,58.828,0s-28.207-192.995-102.657-206.231C896.879,802.053,803.532,869.561,788.67,967.938z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC166",
    d: "M969.015,898.447c12.685,43.57,50.555,86.771,75.188,106.993c24.635,20.224,39.708,21.693,47.431,2.574 c7.721-19.119,25.737-75.372,26.84-89.713c1.103-14.339,1.103-14.339,1.103-14.339s16.82-14.89,10.479-25.37 c-6.342-10.478-28.679-22.612-30.608-43.845c-1.931-21.232,61.31-127.49-15.902-157.639 c-77.211-30.149-189.719-3.677-205.162,10.294c-15.442,13.972-35.296,91.182-26.472,114.715 c8.824,23.53,38.972,88.977,38.972,88.977L969.015,898.447z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M712.563,539.965c77.002-64.876,188.616-76.108,263.621-44.121 c75.005,31.988,140.083,92.653,145.599,189.719c5.515,97.066-49.084,135.12-68.387,133.465s-31.988-5.515-33.643,28.127 c-1.654,33.643-23.163,46.878-20.957-8.272c2.206-55.151,5.515-92.653-27.024-79.417c-32.539,13.236-35.296,45.223-30.884,86.587 c4.412,41.363,28.127,52.393,28.127,52.393s-46.511,68.387-141.371,90.448s-24.634-52.944-84.197-86.036 C683.884,869.769,572.479,657.989,712.563,539.965z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CBDEF",
    d: "M742.344,1113.535c-136.774,95.964-191.926,195.038-143.393,363.898 c48.533,168.861,90.448,305.636,99.272,400.496c8.824,94.858-24.266,158.34-24.266,158.34h509.595 c0,0-25.269-167.102-8.724-279.602c16.543-112.501,21.507-137.319,21.507-137.319l39.324-315.846 c0,0-46.591-53.192-171.232-116.064C939.785,1124.567,742.344,1113.535,742.344,1113.535z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6D2FC",
    d: "M1108.546,1348.479c66.754-83.753,141.187-83.83,205.162,63.975 c63.975,147.806,217.294,441.209,217.294,441.209s112.51,16.546,143.393,34.194c30.887,17.647,51.844,48.531,55.153,78.313 c3.309,29.781,0,70.099,0,70.099h-331.372c0,0-150.555-205.149-233.277-411.956 C1082.177,1417.507,1082.543,1381.105,1108.546,1348.479z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M289,1251.525c364.483,47.162,783.21,119.523,818.845,303.886 c36.764,190.202,75.707,459.405,75.707,459.405s435.801,0,506.656,0c70.853,0,84.158,1.787,86.578,42.909 c2.418,41.122,0,111.339,0,111.339H407c0,0,65.069-195.113,45.715-492.697C433.359,1378.784,289,1251.525,289,1251.525z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#775757",
    d: "M289,1251.525c42.333,36.206,55.333,45.206,306,85.882c300.318,48.732,456.667,121.048,482.667,245.99 S1156,2169.064,1156,2169.064H407c0,0,69.717-143.068-2.29-476.103S289,1251.525,289,1251.525z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#775757",
    d: "M1129.609,2065.098c0,0,532.473,0,571.471,0s29.938-1.033,29.938,36.967s0,67,0,67H1104.11 L1129.609,2065.098z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.374dc55d8f001ad0b74b6b3588cf5e99.svg";
export { ForwardRef as ReactComponent };